import { EmptyComponent } from './empty.component';

export default angular
  .module('sfMobile.components.empty', [
    'sfMobile.templates',
    'pascalprecht.translate',
    'sfMobile.components.information-display',
  ])
  .component('sfEmpty', EmptyComponent).name;
